// MenuPage.jsx
import React from 'react';

const MenuPage = ({ listing, config ,expanded, CatInOneLine}) => {
  const {
    orderDetails,
    generalSettings,
    selectedParty,
    getSystemSettings,
    handleFoodItemClicked,
    flyStart,
    animate,
    buttonDisabled,
    itemImage,
    isFoodLoading
  } = config;

  const handleDisable = (foodItem) => {
    const isDisabled = !!(orderDetails.is_split || (generalSettings &&
      selectedParty?.name.toLowerCase() !== "pre order" &&
      parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
      (foodItem?.stock_qty <= 0 || foodItem?.stock_qty === undefined) &&
      foodItem?.is_deal === 0 && !foodItem?.is_recipe)) || isFoodLoading;
    return isDisabled;
  }

  const Isshowtags = (foodItem) => {
    return (
      generalSettings &&
      selectedParty?.name.toLowerCase() !== "pre order" &&
      parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
      foodItem?.is_deal === 0 &&
      !foodItem?.is_recipe
    );
  };

  const renderStockQty = (foodItem) => {
    if (!foodItem) return null;

    if (foodItem?.stock_qty <= 0 || foodItem?.stock_qty === undefined) {
      return (
        <span className="tag" >Out of stock</span>
      );
    } else {
      return (
        <span className="tag" > Qty : {" " + foodItem?.stock_qty}</span>
      );
    }
  }

  return (
    <div className={`menu-container item-listing ${expanded ?"expanded-coll" :""}${CatInOneLine? "cat-in-one-line":""}  ${itemImage ? "is-listing-layout" : ""}`}>
      <div className="menu-grid">
        {listing.map((foodItem,index) => (
          <div className={`menu-card cursor-pointer
            ${handleDisable(foodItem) ? "disabled" : ""}`}
            ref={flyStart}
            key={index}
            title={foodItem?.item_description}
            onClick={(e) => {
              animate.current = true;
              flyStart.current = e.target;
              if (!buttonDisabled) {
                handleFoodItemClicked(foodItem, e,"is-first");
              }
            }}
          >
            <div className="image-wrapper">
              {!itemImage &&
                <img src={foodItem?.image || "/assets/img/default-item.jpeg"} alt={foodItem?.name} loading="lazy" onError={(e) => { e.target.onerror = null; e.target.src = "/assets/img/default-item.jpeg" }} />
              }
              {Isshowtags(foodItem) &&
                <div className="tag-overlay">
                  {renderStockQty(foodItem)}
                </div>
              }

            </div>
            <p className="menu-name">{foodItem?.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MenuPage;
